import axios from "axios";

//const url = 'https://localhost:44348/api';
const url = 'https://api.pizzadelforno.co.za/api';

// export const getStores = async () => {
//     const { data } = await axios.get(url + '/qsc/getstores')
//     return data
// }

export const getQuestionnaires = async () => {
    const { data } = await axios.get(url + '/qsc/getquestionnaires')
    return data
}

export const getQuestionnaire = async () => {
    const { data } = await axios.get(url + '/qsc/getquestionnaire')
    return data
}

export const getStores = async () => {
    const { data } = await axios.get(url + '/qsc/getstores')
    return data
}

export const postQSC = async (data) => {

    return await axios({
        method: 'post',
        url: url + '/qsc/saveqsc',
        data: data,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export const postImage = async (data, filename, questionId) => {

    return await fetch(url + '/qsc/uploadqscimage',
        {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.tokenKey
            },
            body: JSON.stringify({
                QuestionId: questionId,
                FileName: filename,
                Image: data
            })
        }
    ).then((response) => {
        return response.status;
    })
}

export const authenticate = async (email, password) => {
    return axios.post(url + '/token', null, {
        timeout: 15000,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'username': email,
            'password': password,
        },
    }).then((response) => {
        const access_token = response.data.token.access_token;
        localStorage.setItem('access_token', access_token);
        localStorage.setItem('user', JSON.stringify(response.data.vmuser));
        return true;
    }).catch((error) => {
        alert(error)
        return false;
    })
}
